import React from 'react';
import { Alert } from '@thd-olt-component-react/core-ui';
import { string, shape, bool } from 'prop-types';
import {
  BACKORDERED, LIMITED_STOCK, OUT_OF_STOCK
} from '../../constants';

export const FulfillmentError = ({
  errorType, backOrderedStatus
}) => {

  switch (errorType) {
  case OUT_OF_STOCK:
    return <Alert inline type="danger" title={OUT_OF_STOCK} />;
  case LIMITED_STOCK:
    return (
      <Alert
        inline
        type="warning"
        title={LIMITED_STOCK}
      />
    );
  case BACKORDERED:
    return (
      <Alert
        inline
        type="warning"
        title={`${BACKORDERED}`}
        message={backOrderedStatus.backorderedShipDate ? `until ${backOrderedStatus.backorderedShipDate}` : ''}
      />
    );
  default:
    return null;
  }
};

FulfillmentError.propTypes = {
  backOrderedStatus: shape({
    backOrdered: bool,
    backorderedShipDate: string
  }).isRequired,
  errorType: string
};
FulfillmentError.defaultProps = {
  errorType: null
};
